export { createProperty, createParameter, createType, createPrimitiveType, createCollectionType,
  compileProperties, compileParameters, createResolveType, ONEOF_TYPE_PREFIX } from './src/types-plugin-shared';
export { createNavigation, createCastNavigation, createWithKeyNavigation, createCallNavigation,
  createResourceIdentifier } from './src/resource-identifiers-shared';

